import React, { useContext, useState } from 'react';
import { sessionHelper } from "./SessionHelper";
import { forgottenPassword, changePassword as changePwd, changeTempToUserPwd, getToken, isUserAuthenticated, changeForgottenPassword } from "./WorkerService";

export interface IUserContext {
    isLoading: boolean;
    isAuthenticated: boolean;
    userName: string | undefined;
    // userId: string | undefined;
    login: (username: string, password: string) => Promise<any>;
    forgotPassword: (email: string) => Promise<any>;
    changeForgotPassword: (username: string, password: string, confirmPassword: string, confirmationCode: string) => Promise<any>;
    changeTempToUserPassword: (username: string, oldPassword: string, newPassword: string, confirmPassword: string) => Promise<any>;
    changePassword: (oldPassword: string, newPassword: string, confirmPassword: string) => Promise<any>;
    isUserLoggedIn: () => void;
    logout: () => void;
}

export const UserContext = React.createContext<IUserContext | undefined>(undefined)

export const useUserContext = () => {
    const context = useContext(UserContext);
    if(!context) {
        throw new Error("useUserContext must be used within a UserProvider")
    }
    return context;
};

type Props = {
    children?: React.ReactNode;
};

export const UserProvider: React.FC<Props> = ({ children }) => {

    const [userName, setUserName] = useState("");
    // const [userId, setUserId] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    // useEffect(() => {
    //     isUserLoggedIn();
    // }, []);

    const isUserLoggedIn = () => {
        const isLoggedIn = async () => {
            setIsAuthenticated(await isUserAuthenticated());
            setIsLoading(false);
        }

        try {
            isLoggedIn();
        } catch (error) {
            console.error(error);
            window.location.href = "/login";
        }
    };

    const login = async (username: string, password: string) => {
        try {
            await getToken(username, password);
            setUserName(username);
            // setUserId(result.username);
            setIsAuthenticated(true);
            return { success: true, message: "" };
        } catch (error: any) {
            setUserName("");
            setIsAuthenticated(false);

            let msg = `ERROR: Login failed\n ${error.message}`;
            if(error.message === "16"){
                msg = "NewPasswordRequired"
            }

            return {
                success: false,
                message: msg
            };
        }
    };

    const logout = async () => {
        try {
            sessionHelper.accessToken = undefined;
            sessionHelper.refreshToken = undefined;
            setUserName("");
            setIsAuthenticated(false);
            window.location.href = "/login";
        } catch (error: any) {
            // return {
            //     success: false,
            //     message: `ERROR: Logout failed - ${error.message} `,
            // };
        }
    };

    const forgotPassword = async (username: string) => {
        try {
           return await forgottenPassword(username);
        } catch (error: any) {
            throw error;
        }
    };

    const changeForgotPassword = async (username: string, password: string, confirmPassword: string, confirmationCode: string) => {
        try {
            if(password !== confirmPassword){
                throw new Error("Password and confirm password do not match.");
            }            
            return await changeForgottenPassword(username, password, confirmationCode);
        } catch (error: any) {
            if(error.message){
                let errmsg = getErrorDescription(error.message);
                throw new Error(errmsg);
            }
            throw error;
        }
    };

    const changePassword = async (oldPassword: string, newPassword: string, confirmPassword: string) => {
        try {
            return await changePwd(oldPassword, newPassword, confirmPassword);

        } catch (error: any) {
            if(error.message){
                let errmsg = getErrorDescription(error.message);
                throw new Error(errmsg);
            }
            throw error;
        }
    };

    const getErrorDescription = (errorCode: string) => {

        let errdesc;
        switch (errorCode) {
            case "17":
                errdesc = "Invalid password";
                break;
            case "18":
                errdesc = "Invalid verification code entered";
                break;
            case "19":
                errdesc = "Exceeded the no. of limits to change password";
                break;
            default:
                errdesc = `Message: ${errorCode}`;
        }

        return errdesc;
    };

    const changeTempToUserPassword = async (username: string, tempPassword: string, newPassword: string, confirmPassword: string) => {
        try {
            return await changeTempToUserPwd(username, tempPassword, newPassword, confirmPassword);
        } catch (error: any) {
            let msg = getErrorDescription(error.message);

            return {
                success: false,
                message: msg
            };
        }
    };

    const userProvider: IUserContext = {
        isLoading,
        isAuthenticated,
        userName,
        // userId,
        login,
        forgotPassword,
        changeForgotPassword,
        changeTempToUserPassword,
        changePassword,
        isUserLoggedIn,
        logout,
    };

    return (
        <UserContext.Provider value={userProvider}>
            {children}
        </UserContext.Provider>
    );
}